import type * as monaco from 'monaco-editor'
export const languageID = 'Fplus'
export const languageExtensionPoint: monaco.languages.ILanguageExtensionPoint =
  {
    id: languageID,
  }
